"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.rowTypes = exports.ProjectWallRow = exports.ProjectRow = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _PlacerRow = require("./PlacerRow");
var _Erp = require("./Erp");
var _RowSlot = require("./RowSlot");
var _Rule = require("./Rule");
var _patterns = require("../patterns");
var ProjectRow = /*#__PURE__*/function () {
  function ProjectRow(json) {
    (0, _classCallCheck2["default"])(this, ProjectRow);
    this.uniqueid = null;
    this.id = null;
    this.catalog = null;
    this.model = null;
    this.modeldes = null;
    this.neutro = null;
    this.item = null;
    this.cModel = null;
    this.cmodel = null;
    this.reg = null;
    this.cod = null;
    this.auto = false;
    this.local = false;
    this.wallItem = false;
    this.l = 0;
    this.a = 0;
    this.p = 0;
    this.pl = 0;
    this.pa = 0;
    this.pp = 0;
    this.nl = 0;
    this.na = 0;
    this.np = 0;
    this.axy = 0;
    this.axz = 0;
    this.ayz = 0;
    this.ul = 0;
    this.ua = 0;
    this.up = 0;
    this.skipBasket = false;
    this.jeval3ddone = false;
    this.testobox = '';
    this.erp = [];
    this.job = null;
    this.img = null;
    this.des = '';
    this.boxid = null;
    this._configure = false;
    this.side = ["0", "0", "0", "0", "0", "0", "0", "3"];
    this.vheader = null;
    this.load = '';
    this.primoCaricamento = '1';
    this.isloaditem = false;
    this.placer = [];
    this.classicPlacer = [];
    this.dragger2D = [];
    this.parent = null;
    this.father = null;
    this.clPlacerChilds = [];
    this.eval3dris = {};
    this.firstTime = null;
    this.extraEval = {};
    this.altezze = [];
    this.note = '';
    this.regtrad = null;
    this.currency = null;
    this.rule = null;
    this.extra = {};
    this.ghost = false;
    this.isManualPan = false;
    if (json) {
      this.uniqueid = json.uniqueid !== null && json.uniqueid !== undefined ? json.uniqueid : null;
      this.id = json.id || null;
      this.catalog = json.catalog || null;
      this.model = json.model || null;
      this.modeldes = json.modeldes || null;
      this.neutro = json.neutro || null;
      this.cmodel = json.cModel || json.cmodel || null;
      this.reg = json.reg || null;
      this.cod = json.cod || null;
      this.auto = json.auto || false;
      this.local = json.local || false;
      this.wallItem = json.wallItem || false;
      this.l = json.l || 0;
      this.a = json.a || 0;
      this.p = json.p || 0;
      this.pl = json.pl || 0;
      this.pa = json.pa || 0;
      this.pp = json.pp || 0;
      this.nl = json.nl || 0;
      this.na = json.na || 0;
      this.np = json.np || 0;
      this.axy = json.axy || 0;
      this.axz = json.axz || 0;
      this.ayz = json.ayz || 0;
      this.ul = json.ul || 0;
      this.ua = json.ua || 0;
      this.up = json.up || 0;
      this.skipBasket = json.skipBasket || false;
      this.jeval3ddone = json.jeval3ddone || false;
      this.testobox = json.testobox || '';
      this.job = json.job || null;
      this.img = json.img || null;
      this.des = json.des || '';
      this.boxid = json.boxid !== null && json.boxid !== undefined ? json.boxid : null;
      this._configure = json._configure || false;
      this.side = json.side || ["0", "0", "0", "0", "0", "0", "0", "3"];
      this.vheader = json.vheader || null;
      this.load = json.load || '';
      this.primoCaricamento = json.primoCaricamento !== null && json.primoCaricamento !== undefined ? json.primoCaricamento : 1;
      this.isloaditem = json.isloaditem || false;
      this.eval3dris = json.eval3dris || {};
      this.firstTime = json.firstTime || null;
      this.extraEval = json.extraEval || {};
      this.altezze = json.altezze || [];
      this.note = json.note || '';
      this.classicPlacer = json.classicPlacer || [];
      this.father = null;
      this.clPlacerChilds = [];
      this.dragger2D = json.dragger2D || [];
      this.ghost = json.ghost || false;
      this.isManualPan = json.isManualPan || false;
      this.regtrad = json.regtrad || null;
      this.setClassicPlacers(json.father, json.clPlacerChilds);
      if (json.erp) this.setErp(json.erp);
      if (json.placer) {
        for (var i = 0; i < json.placer.length; i++) {
          this.placer.push(new _PlacerRow.PlacerRow(json.placer[i]));
        }
      }
      this.checkFields(json);
    }
  }
  (0, _createClass2["default"])(ProjectRow, [{
    key: "createMemento",
    value: function createMemento() {
      return new _patterns.Memento(JSON.parse((0, _stringify["default"])(this)));
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      var _context;
      var withTaxes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var withCamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var withQt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var tot = 0;
      (0, _forEach["default"])(_context = this.erp).call(_context, function (e) {
        tot += e.getTotal(withTaxes, withCamp, withQt);
      });
      return tot;
    }
  }, {
    key: "getWeight",
    value: function getWeight() {
      var _context2;
      var tot = 0;
      (0, _forEach["default"])(_context2 = this.erp).call(_context2, function (y) {
        tot += y.getWeight();
      });
      return tot;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      var _context3;
      var tot = 0;
      (0, _forEach["default"])(_context3 = this.erp).call(_context3, function (y) {
        tot += y.getVolume();
      });
      return tot;
    }
  }, {
    key: "setErp",
    value: function setErp(rowData) {
      this.erp = [];
      for (var i = 0; i < rowData.length; i++) {
        var erpObj = new _Erp.Erp(rowData[i]);
        this.erp.push(erpObj);
      }
    }
  }, {
    key: "setClassicPlacers",
    value: function setClassicPlacers(jsonFather, jsonChilds) {
      if (jsonFather) {
        this.father = new _RowSlot.RowSlot(jsonFather.idRow, jsonFather.idSlot, jsonFather.slotType);
      }
      if (jsonChilds) {
        for (var i = 0; i < jsonChilds.length; i++) {
          this.clPlacerChilds.push(new _RowSlot.RowSlot(jsonChilds[i].idRow, jsonChilds[i].idSlot, jsonChilds[i].slotType));
        }
      }
    }
  }, {
    key: "getFreeRowSlots",
    value: function getFreeRowSlots() {
      var freeSlots = [];
      for (var i = 0; i < this.classicPlacer.length; i++) {
        var clID = this.classicPlacer[i].id;
        var found = false;
        for (var k = 0; k < this.clPlacerChilds.length && !found; k++) {
          if (clID == this.clPlacerChilds[k].idSlot) {
            found = true;
          }
        }
        if (!found) {
          freeSlots.push(new _RowSlot.RowSlot(this.uniqueid, this.classicPlacer[i].id, this.classicPlacer[i].tipo));
        }
      }
      return freeSlots;
    }
  }, {
    key: "isSlotFree",
    value: function isSlotFree(slotID, slotType) {
      var _context4, _context5;
      var free = true;
      var bfree = !(0, _find["default"])(_context4 = this.clPlacerChilds).call(_context4, function (r) {
        return slotID === r.idSlot;
      });
      if (bfree) bfree = !(0, _find["default"])(_context5 = this.classicPlacer).call(_context5, function (r) {
        return slotID === r.id && r.tipo != slotType;
      });
      return bfree;
    }
  }, {
    key: "getClassicPlacerByID",
    value: function getClassicPlacerByID(id) {
      var classicPlacer = null;
      for (var i = 0; i < this.classicPlacer.length && !classicPlacer; i++) {
        if (this.classicPlacer[i].id == id) classicPlacer = this.classicPlacer[i];
      }
      return classicPlacer;
    }
  }, {
    key: "setRule",
    value: function setRule(rule) {
      if (!(rule instanceof _Rule.Rule)) throw 'rule is not a instance of Rule';
      this.rule = rule;
      this.reg = rule.reg;
    }
  }, {
    key: "checkFields",
    value: function checkFields(json) {
      var _context6,
        _this = this;
      (0, _map["default"])(_context6 = (0, _keys["default"])(json)).call(_context6, function (key) {
        if (!_this.hasOwnProperty(key)) console.warn('%c' + key + '%c is ignored in ProjectRow class', 'color: blue', 'color: inherit');
      });
    }
  }, {
    key: "mergeJson",
    value: function mergeJson(json) {
      if (json) {
        for (var k in json) {
          if (this.hasOwnProperty(k)) {
            if (k === 'erp') this.setErp(json[k]);else if (k === 'placer') {
              this.placer = [];
              if (json[k]) {
                for (var i = 0; i < json[k].length; i++) {
                  this.placer.push(new _PlacerRow.PlacerRow(json[k][i]));
                }
              }
            } else this[k] = json[k];
          }
        }
      }
    }
  }, {
    key: "mergeEvalData",
    value: function mergeEvalData(data) {
      if (data.rule) {
        this.reg = data.rule.reg;
        if (data.rule.extraEval) this.extraEval = data.rule.extraEval;
        if (data.rule.nl) this.nl = data.rule.nl;else this.nl = 0;
        if (data.rule.na) this.na = data.rule.na;else this.na = 0;
        if (data.rule.np) this.np = data.rule.np;else this.np = 0;
        if (data.rule.ul) this.ul = data.rule.ul;else this.ul = 0;
        if (data.rule.ua) this.ua = data.rule.ua;else this.ua = 0;
        if (data.rule.up) this.up = data.rule.up;else this.up = 0;
        if (data.rule.l) this.l = data.rule.l;else this.l = 0;
        if (data.rule.a) this.a = data.rule.a;else this.a = 0;
        if (data.rule.p) this.p = data.rule.p;else this.p = 0;
      } else if (data.rinfo) {
        if (data.rinfo.nl) this.nl = data.rinfo.nl;else this.nl = 0;
        if (data.rinfo.na) this.na = data.rinfo.na;else this.na = 0;
        if (data.rinfo.np) this.np = data.rinfo.np;else this.np = 0;
        if (data.rinfo.ul) this.ul = data.rinfo.ul;else this.ul = 0;
        if (data.rinfo.ua) this.ua = data.rinfo.ua;else this.ua = 0;
        if (data.rinfo.up) this.up = data.rinfo.up;else this.up = 0;
        if (data.rinfo.l) this.l = data.rinfo.l;else this.l = 0;
        if (data.rinfo.a) this.a = data.rinfo.a;else this.a = 0;
        if (data.rinfo.p) this.p = data.rinfo.p;else this.p = 0;
      } else {
        throw 'Missing rule jEval3D2';
      }
      if (data.placer && data.placer.length) {
        for (var i = 0; i < data.placer.length; i++) {
          if (this.placer[i]) {
            var jsonPlacer = data.placer[i];
            var rowPlacer = this.placer[i];
            if (rowPlacer.neutro === jsonPlacer.neutro && rowPlacer.model === jsonPlacer.model && rowPlacer.catalog === jsonPlacer.catalogo) {
              this.placer[i].mergeJson(data.placer[i]);
            } else {
              this.placer[i] = new _PlacerRow.PlacerRow(data.placer[i]);
            }
          } else {
            this.placer.push(new _PlacerRow.PlacerRow(data.placer[i]));
          }
        }
      } else {
        this.placer = [];
      }
      this.extraEval = data.extraEval;
      this.altezze = data.altezze;
      this.classicPlacer = data.classicPlacer;
      this.dragger2D = data.dragger2D;
      this.jeval3ddone = true;
      this.job = data.job;
      this.primoCaricamento = '0';
      this.firstTime = 0;
      if (data.hasGraphic && data.eval3dris) this.eval3dris = data.eval3dris;
      if (data.hasPrices && data.erp) this.setErp(data.erp);
    }
  }, {
    key: "initRowFromRule",
    value: function initRowFromRule(catalog, headerVar, rule) {
      if (!catalog || catalog.length == 0) throw "Missing catalog from init row";
      if (!rule) throw "Missing rule from init row";
      this.catalog = catalog;
      this.side = rule.lato;
      this.l = rule.l;
      this.a = rule.a;
      this.p = rule.p;
      this.model = rule.model;
      this.cmodel = rule.cModel;
      this.reg = rule.reg;
      this.cod = rule.item;
      this.des = rule.desItem ? rule.desItem : this.des;
      this.modeldes = rule.desModel ? rule.desModel : this.modeldes;
      this.neutro = rule.neutro;
      this.isloaditem = true;
      this._configure = true;
      this.vheader = headerVar;
      this.primoCaricamento = '1';
      this.load = null;
      this.jeval3ddone = false;
      this.reg = rule.reg;
      this.setRule(rule);
    }
  }, {
    key: "getErpMergedByCode",
    value: function getErpMergedByCode() {
      var _this2 = this;
      var merged = [];
      var _loop = function _loop() {
        var erp = _this2.erp[i];
        var find = (0, _find["default"])(merged).call(merged, function (r) {
          return r.cod === erp.cod;
        });
        if (find) find.qt = find.qt + erp.qt;else merged.push(new _Erp.Erp(JSON.parse((0, _stringify["default"])(erp))));
      };
      for (var i = 0; i < this.erp.length; i++) {
        _loop();
      }
      return merged;
    }
  }], [{
    key: "getRowData",
    value: function getRowData(row) {
      var forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var placerIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var data = {
        model: row.model || '',
        neutro: row.neutro || '',
        item: row.cod || '',
        cmodel: row.cmodel || '',
        reg: row.reg || '',
        angle: row.extra && !isNaN(row.extra.angle) ? row.extra.angle : null
      };
      if (row.placer && row.placer.length) {
        var _context7;
        data.placer = [];
        (0, _forEach["default"])(_context7 = row.placer).call(_context7, function (r) {
          data.placer.push({
            variants: r.variants,
            catalogo: r.catalog,
            model: r.model,
            neutro: r.neutro,
            reg: r.reg
          });
        });
      }
      if (placerIndex > -1 && row.placer[placerIndex]) {
        data.curplacer = placerIndex + 1;
      }
      if (forced) data.force = 1;
      return data;
    }
  }, {
    key: "baserowdata",
    value: function baserowdata(row) {
      row.clPlacerChilds;
      return {
        id: row.uniqueid,
        catalog: row.catalog,
        cmodel: row.cmodel,
        neutro: row.neutro,
        model: row.model,
        cod: row.cod,
        reg: row.reg,
        auto: row.auto,
        pl: row.pl,
        pa: row.pa,
        pp: row.pp,
        nl: row.nl,
        na: row.na,
        np: row.np,
        ul: row.ul,
        ua: row.ua,
        up: row.up,
        axy: row.axy,
        axz: row.axz,
        ayz: row.axz,
        notInserted: row.notInserted,
        father: row.father,
        clPlacerChilds: row.clPlacerChilds,
        classicPlacer: row.classicPlacer,
        uniqueid: row.uniqueid,
        pann: null
      };
    }
  }]);
  return ProjectRow;
}();
exports.ProjectRow = ProjectRow;
var rowTypes = {
  BOX: 0,
  TOP: 1,
  WALL_ITEM: 2,
  MANUAL: 3
};
exports.rowTypes = rowTypes;
var ProjectWallRow = /*#__PURE__*/function () {
  function ProjectWallRow(_eval) {
    (0, _classCallCheck2["default"])(this, ProjectWallRow);
    this._internalEval = null;
    this._internalEval = _eval;
  }
  (0, _createClass2["default"])(ProjectWallRow, [{
    key: "getUniqueId",
    value: function getUniqueId() {
      return this._internalEval.uniqueid;
    }
  }, {
    key: "resolveEvalData",
    value: function resolveEvalData(data) {
      if (this._internalEval.rule) {
        data.reg = this._internalEval.rule.reg;
        if (this._internalEval.rule.extraEval) data.extraEval = this._internalEval.rule.extraEval;
        if (this._internalEval.rule.nl) data.nl = this._internalEval.rule.nl;else data.nl = 0;
        if (this._internalEval.rule.na) data.na = this._internalEval.rule.na;else data.na = 0;
        if (this._internalEval.rule.np) data.np = this._internalEval.rule.np;else data.np = 0;
        if (this._internalEval.rule.ul) data.ul = this._internalEval.rule.ul;else data.ul = 0;
        if (this._internalEval.rule.ua) data.ua = this._internalEval.rule.ua;else data.ua = 0;
        if (this._internalEval.rule.up) data.up = this._internalEval.rule.up;else data.up = 0;
        if (this._internalEval.rule.l) data.l = this._internalEval.rule.l;else data.l = 0;
        if (this._internalEval.rule.a) data.a = this._internalEval.rule.a;else data.a = 0;
        if (this._internalEval.rule.p) data.p = this._internalEval.rule.p;else data.p = 0;
      } else if (this._internalEval.rinfo) {
        if (this._internalEval.rinfo.nl) data.nl = this._internalEval.rinfo.nl;else data.nl = 0;
        if (this._internalEval.rinfo.na) data.na = this._internalEval.rinfo.na;else data.na = 0;
        if (this._internalEval.rinfo.np) data.np = this._internalEval.rinfo.np;else data.np = 0;
        if (this._internalEval.rinfo.ul) data.ul = this._internalEval.rinfo.ul;else data.ul = 0;
        if (this._internalEval.rinfo.ua) data.ua = this._internalEval.rinfo.ua;else data.ua = 0;
        if (this._internalEval.rinfo.up) data.up = this._internalEval.rinfo.up;else data.up = 0;
        if (this._internalEval.rinfo.l) data.l = this._internalEval.rinfo.l;else data.l = 0;
        if (this._internalEval.rinfo.a) data.a = this._internalEval.rinfo.a;else data.a = 0;
        if (this._internalEval.rinfo.p) data.p = this._internalEval.rinfo.p;else data.p = 0;
      } else {
        throw 'Missing rule jEval3D2';
      }
      data.placer = [];
      data.extraEval = this._internalEval.extraEval;
      data.altezze = this._internalEval.altezze;
      data.classicPlacer = this._internalEval.classicPlacer;
      data.dragger2D = this._internalEval.dragger2D;
      data.jeval3ddone = true;
      data.job = this._internalEval.job;
      data.primoCaricamento = '0';
      data.firstTime = 0;
    }
  }]);
  return ProjectWallRow;
}();
exports.ProjectWallRow = ProjectWallRow;
//# sourceMappingURL=ProjectRow.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/ProjectRow.js
// module id = 192
// module chunks = 142